import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-item-snippet-com',
  templateUrl: './item-snippet.com.html'
})

export class ItemSnippetComponent {

  @Input() item = null
  @Input() terse = true
  data = {
    fields: [
      { name: '品牌', key: 'brand' },
      { name: '类目', key: 'category' },
      { name: '名字', key: 'name' },
      { name: '采购', key: 'purchaser' },
      { name: '成本', key: 'cost' }
    ],
    moreFields: [
      { name: '税前价', key: 'pre_tax_price' },
      { name: '税率', key: 'tax_rate' },
      { name: '酬劳率', key: 'commission_rate' },
      { name: '汇率', key: 'exchange_rate' },
      { name: '购买日', key: 'purchase_date' }
    ]
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/holders/item-snippet/item-snippet.com.ts